import { render } from "./Return.vue?vue&type=template&id=e8a2a2c4"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"

import "./Return.vue?vue&type=style&index=0&id=e8a2a2c4&lang=css"
script.render = render

export default script